import React from 'react';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import ScriptTag from 'react-script-tag';

import './ProjectCard.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const ProjectCard = ({ projectName, projectImageSrc, projectImageAlt, projectSubtitle, projectText, projectCode }) => {

  return (
    <>
      <ScriptTag type="text/javascript" src="https://cdn.rawgit.com/google/code-prettify/master/loader/run_prettify.js?skin=sunburst" />
      <Col xs="12" md="6" className="card-col">
        <Card>
          <Tab.Container defaultActiveKey="description">
            <Card.Header>
              <Nav variant="tabs">
                <Nav.Item>
                  <Nav.Link eventKey="description" className="card-nav">Description</Nav.Link>
                </Nav.Item>
                {projectCode === "" ? <></> :
                  <Nav.Item>
                      <Nav.Link eventKey="code" className="card-nav">Code</Nav.Link>
                  </Nav.Item>
                }
              </Nav>
            </Card.Header>
            <Tab.Content>
              <Tab.Pane eventKey="description">
                <Card.Body>
                  <Card.Img variant="top" alt={projectImageAlt} src={projectImageSrc} />
                  <Card.Title>{projectName}</Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">{projectSubtitle}</Card.Subtitle>
                  <Card.Text>{projectText}</Card.Text>
                </Card.Body>
              </Tab.Pane>

              <Tab.Pane eventKey="code">
                <Card.Body>
                  <pre style={{margin:"0px"}} className="prettyprint lang-java">{projectCode}</pre>
                </Card.Body>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Card>
      </Col>

    </>
  );
}

export default ProjectCard;
